import { render, staticRenderFns } from "./LtkFeedItem.vue?vue&type=template&id=c3007426&scoped=true"
import script from "./LtkFeedItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./LtkFeedItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LtkFeedItem.vue?vue&type=style&index=0&id=c3007426&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3007426",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LtkProfileHeader: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Ltk/LtkProfileHeader.vue').default,CCol: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CGrid/CCol.vue').default,LtkHeroImage: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Ltk/LtkHeroImage.vue').default,LtkPostLike: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Ltk/LtkPostLike.vue').default,LtkProduct: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Ltk/LtkProduct.vue').default,CSheet: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CSheet/CSheet.vue').default,CRow: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CGrid/CRow.vue').default})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Intersect from 'vuetify/lib/directives/intersect'
installDirectives(component, {Intersect})
